import type { InvestmentAccount } from 'api/client/models';

function getDistinctValues(array: InvestmentAccount[]) {
  const tmp = array.map((it) => parseInt(it.brokerageHouseName, 10));
  return tmp;
}

function mapSelectedAccounts(array: InvestmentAccount[], selected: any) {
  let noneSelected = false;
  if (
    selected[selected.length - 1] === 'all' &&
    array.length === selected.length - 1
  ) {
    noneSelected = true;
  }

  if (noneSelected) {
    return array.map((it) => {
      return { ...it, selected: false };
    });
  }
  const allSelected = selected.includes('all');
  return array.map((it) => {
    return {
      ...it,
      selected: allSelected || selected.includes(it.accountId),
    };
  });
}

export { getDistinctValues, mapSelectedAccounts };
